<div *ngIf="customer">
  <h4><p class="text-center">Klantinformatie van {{customer.name}}</p></h4>


  <div class="row ui-toolbar">
    <div class="col-6">
      <button type="button" class="btn btn-outline-secondary" (click)="printCustomer('printable')">
        <div class="d-sm-block">
          <i class="fa fa-print"></i>
        </div>
        <div class="d-none d-sm-block last">
          Afdrukken
        </div>
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="historyCustomer()">
        <div class="d-sm-block">
          <i class="fa fa-history"></i>
        </div>
        <div class="d-none d-sm-block last">
          Vorig onderhoud
        </div>
      </button>
    </div>
    <div class="col-6">
      <div class="pull-right">
        <button type="button" class="btn btn-outline-secondary" [disabled]="!isFinished()" (click)="editCustomer()">
          <div class="d-sm-block">
            <i class="fa fa-pencil"></i>
          </div>
          <div class="d-none d-sm-block last">
            Bewerken
          </div>
        </button>
        <button type="button" class="btn btn-outline-danger" *ngIf="isAdmin()" (click)="deleteCustomer()">
          <div class="d-sm-block">
            <i class="fa fa-trash-o"></i>
          </div>
          <div class="d-none d-sm-block last">
            Verwijderen
          </div>
        </button>
      </div>
    </div>
  </div>
  <div class="row ui-toolbar-second">
    <div class="col-12">
      <button type="button" *ngIf="customer.machines.length > 0 && isFinished()" class="btn btn-info btn-block" (click)="startMaintenance()">
        <i class="fa fa-play"></i>
        Onderhoud starten
      </button>
      <button type="button" *ngIf="customer.machines.length > 0 && !isFinished()" class="btn btn-success btn-block" (click)="finishMaintenance()">
        <i class="fa fa-check"></i>
        Onderhoud afronden
      </button>
    </div>
  </div>


  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-5">
              <strong>Straat</strong>
            </div>
            <div class="col-7">
              {{customer.street}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Postcode</strong>
            </div>
            <div class="col-7">
              {{customer.postal}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Plaats</strong>
            </div>
            <div class="col-7">
              {{customer.city}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Telefoon</strong>
            </div>
            <div class="col-7">
              {{customer.phonenumber}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Email</strong>
            </div>
            <div class="col-7">
              {{customer.email}}
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-5">
              <strong>Contact</strong>
            </div>
            <div class="col-7">
              {{customer.contact}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Contact telefoon</strong>
            </div>
            <div class="col-7">
              {{customer.contactPhone}}
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-5">
              <strong>Abonnement</strong>
            </div>
            <div class="col-7">
              {{customer.subscription}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Provisie</strong>
            </div>
            <div class="col-7">
              {{customer.provision}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"><strong>Provisie</strong></div>
        <div class="col-12">{{customer.notes}}</div>
      </div>
    </div>
  </div>

  <h4><p class="text-center">Machines</p></h4>
  <div class="row ui-toolbar">
    <div class="col-12">
      <label class="form-check-label">
        <input class="form-check-input" type="checkbox" [checked]="showDeleted" (change)="toonVerwijderd()">
        Toon verwijderd
      </label>
      <button type="button" class="btn btn-outline-secondary pull-right" (click)="addMachine()">
        Toevoegen
      </button>
    </div>
  </div>
  <p-dataTable [value]="machines" [rows]="10" [paginator]="true" [pageLinks]="5"
               scrollable="true" selectionMode="single" [(selection)]="selectedMachine">
    <p-column field="name" header="Naam" [sortable]="true"></p-column>
    <p-column field="type" header="Type" [sortable]="true"></p-column>
    <p-column field="serial" header="Serienummer" [sortable]="true"></p-column>
  </p-dataTable>

  <p-dialog header="Onderhoud afronden" [(visible)]="displayNewApointment" [modal]="true">
    <pre class="alert alert-danger" *ngIf="newError">{{newError}}</pre>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Type</label>
      <div class="col-md-9 col-sm-12"><p-dropdown class="dropdown" [options]="maintenanceTypes" [(ngModel)]="selectedMaintenance"></p-dropdown></div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Werkuren</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="workhours" type="number"></div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Reisuren</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="travelhours" type="number"></div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Kilometers</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="traveldistance" type="number"></div>
    </div>

    <div class="form-group row" *ngIf="!isIncident()">
      <label class="col-form-label col-md-3 col-sm-12">Datum</label>
      <div class="col-md-9 col-sm-12">
        <p-calendar [(ngModel)]="newDate" dateFormat="dd-mm-yy"></p-calendar>
      </div>
    </div>

    <p-footer>
      <button type="button" class="btn btn-primary" (click)="saveNewApointment()">
        Afronden
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="displayNewApointment = false">
        Annuleren
      </button>
    </p-footer>
  </p-dialog>
</div>

<div *ngIf="customer" [hidden]="true" id="printable" style="background-color: white; padding: 10px;">
  <h2>Klantinformatie van {{customer.name}}</h2>

  <table style="width:100%" class="table">
    <tr>
      <th align="left">Straat</th>
      <td>{{customer.street}}</td>
    </tr>
    <tr>
      <th align="left">Postcode</th>
      <td>{{customer.postal}}</td>
    </tr>
    <tr>
      <th align="left">Plaats</th>
      <td>{{customer.city}}</td>
    </tr>
    <tr>
      <th align="left">Telefoon</th>
      <td>{{customer.phonenumber}}</td>
    </tr>
    <tr>
      <th align="left">Email</th>
      <td>{{customer.email}}</td>
    </tr>
    <tr>
      <th align="left">Abonnement</th>
      <td>{{customer.subscription}}</td>
    </tr>
    <tr>
      <th align="left">Provisie</th>
      <td>{{customer.provision}}</td>
    </tr>
    <tr>
      <th align="left">Contactpersoon</th>
      <td>{{customer.contact}}</td>
    </tr>
    <tr>
      <th align="left">Contactpersoon telefoon</th>
      <td>{{customer.contactPhone}}</td>
    </tr>
    <tr>
      <th align="left" colspan="2">Notities</th>
    </tr>
    <tr>
      <td colspan="2">{{customer.notes}}</td>
    </tr>
  </table>

  <h2>Apparaten</h2>

  <table style="width:100%; border-collapse:collapse;" class="table">
    <thead>
    <tr>
      <th align="left">Naam</th>
      <th align="left">Type</th>
      <th align="left">Serienummer</th>
      <th align="left">Bouwjaar</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let machine of printMachines">
      <td style="border-top:1px solid black">{{machine.name}}</td>
      <td style="border-top:1px solid black">{{machine.type}}</td>
      <td style="border-top:1px solid black">{{machine.serial}}</td>
      <td style="border-top:1px solid black">{{machine.manufactureYear}}</td>
    </tr>
    </tbody>
  </table>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/customer/details/customer.details.component.html